export default {
  cashTable: {
    year: '',
    jan: 'JAN',
    feb: 'FEB',
    mar: 'MAR',
    apr: 'APR',
    may: 'MAY',
    jun: 'JUN',
    jul: 'JUL',
    aug: 'AUG',
    sep: 'SEP',
    oct: 'OCT',
    nov: 'NOV',
    dec: 'DEC',
    total: 'TOTAL',
    yield: 'YIELD',
  },
  listTab: {
    divHis: 'Dividend History and Forecast',
  },
  disclaimerContent: `FiinGroup will not accept any liability for loss or damage as a result of reliance on the
     information provided above. Please be fully informed that the official number is not provided by FiinGroup but
     rather by companies, so the predicted number may not be accurate and should be considered for reference purpose
     only. FiinGroup does not  bear any responsibility for any losses you might incur as a result of using this data.`,
  disclaimer: `*Disclaimer: `,
  titleLeftPE: 'P/E Ratio',
  titleRightPE: 'Div. Yield(%)',
  titleLeftDE: 'Earnings & Div. (VND)',
  titleRightDE: 'Div. Payout Ratio(%)',
  titlePE: 'PRICE EARNINGS RATIO - DIVIDEND YIELD',
  priceEarnings: 'Price Earnings Ratio',
  dyLegend: 'Dividend Yield',
  dy: 'Dividend Yield: ',
  pe: 'P/E Ratio: ',
  dyPercent: 'Div Yield:  {0}%',
  titleDE: 'EARNINGS AGAINST DIVIDENDS',
  EPS: 'EPS',
  DPS: 'DPS',
  dividendPayout: 'Dividend Payout Ratio',
  EPSTooltip: 'EPS: ',
  DPSTooltip: 'DPS: ',
  dividendPayoutTooltip: 'Dividend Payout Ratio: ',
  estimatedNumber: 'Estimated number on the annual plan',
  expectedNumber: 'Expected number by FiinTrade',
  cellTooltip: 'Paid %{value} for %{year}',
};
